<template>
  <fieldset class="rating">
    <template v-for="star in stars">
      <input
        v-model="rating"
        type="radio"
        :id="star.id"
        :name="'rating-' + id"
        :value="star.value"
        disabled
      />
      <label :class="star.class" :for="star.id"></label>
    </template>
  </fieldset>
</template>

<script>
export default {
  name: 'RatingStars',
  props: {
    nbVote: {
      type: Number,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      stars: [],
    };
  },
  computed: {
    rating() {
      return Math.round(this.nbVote * 2) / 2;
    },
  },
  created() {
    for (let i = 5; i > 0; i -= 0.5) {
      const star = {
        id: 'star-' + i + this.id,
        value: i,
        class: i % 1 === 0 ? 'full' : 'half',
      };
      this.stars.push(star);
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
//colors
$gray: #ddd;
$gold: #ffa500;
$gold-light: #ffd700;

fieldset {
  margin: 0;
  padding: 0;
  width: 100px;
  transform: scale(0.8);
  transform-origin: left;
}
label {
  margin: 0;
  padding: 0;
}

.rating {
  border: none;
  float: left;
  > input {
    display: none;
    &:checked {
      ~ label {
        color: $gold;
      }
    }
  }
  > label {
    color: $gray;
    float: right;
    &:before {
      margin: 0 2px;
      font-size: 1em;
      font-family: 'live-icon';
      display: inline-block;
      content: '\e90e';
    }
    &:hover ~ input:checked ~ label {
      color: $gold-light;
    }
  }
  > .half:before {
    content: '\e90f';
    position: absolute;
    margin-left: -1.5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/components/RatingStars.vue